import React from "react";
import { Formik, Form, Field } from "formik";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function FrequentConceptUsageForm({ concept, onSubmit, onCancel }) {
    const { t } = useTranslation();

    const defaults = {
        usageCount: concept?.usageCount ?? 0
    };

    const validate = values => {
        const errors = {};
        const parsed = parseInt(values.usageCount, 10);
        if (values.usageCount === "" || values.usageCount === null || values.usageCount === undefined)
            errors.usageCount = t('settings.settings.frequentConcepts.requiredUsageCount');
        else if (Number.isNaN(parsed) || parsed < 0)
            errors.usageCount = t('settings.settings.frequentConcepts.invalidUsageCount');
        return errors;
    };

    return (
        <Modal show onHide={onCancel}>
            <Formik initialValues={defaults} validate={validate} onSubmit={values => onSubmit(parseInt(values.usageCount, 10))}>
                {({ errors }) => (
                    <Form>
                        <Modal.Header closeButton>
                            <Modal.Title>{t('settings.settings.frequentConcepts.edit')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="form-group">
                                <label>{t('settings.settings.frequentConcepts.columns.term')}</label>
                                <div>{concept?.description}</div>
                            </div>
                            <div className="form-group">
                                <label>{t('settings.settings.frequentConcepts.columns.usageCount')}</label>
                                <Field type="number" min={0} name="usageCount" className="form-control" />
                                {errors.usageCount && <div className="text-danger">{errors.usageCount}</div>}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={onCancel}>{t('buttons.cancel')}</Button>
                            <Button type="submit" variant="primary">{t('buttons.save')}</Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
}
